module.exports = __webpack_public_path__ + "static/media/blockquote.b74f4faf.svg";